const confirmLabel = 'Remove'
export default confirmLabel;